import { render } from "./FooterPattern.vue?vue&type=template&id=ec3321a2"
import script from "./FooterPattern.vue?vue&type=script&lang=js"
export * from "./FooterPattern.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__